import { object, constants, getAbValue } from 'common/helpers'
import { getCookieValue, getFeatureToggle } from 'helpers'


export const initialState = {
  isFetching: false,
  isSubscriptionExist: false,
  isEcommerceExist: false,
  isBillingError: false,
  subscription: {
    discount: null,
    shipping: null,
    // price: null,
  },
  cart: {
    discount: null,
    shipping: null,
    price: null,
  },
  bill: {
    tax: null,
    price: null,
    credits: null,
    discount: null,
    shipping: null,
    upchargePrice: null,
    ecommerceCredits: null,
  },
  pickedProducts: null,
  subscriptionCasePrice: false,
  coupon: {
    id: null,
    code: null,
    error: null,
    isDisabled: (() => {
      const referrerLandingPageURL  = getCookieValue(constants.cookieNames.referrerLandingPageURL)

      const isFromUpgradableLanding = (
        /\.co\/$/.test(referrerLandingPageURL)
        || /\.org\/twoitems-70off$/.test(referrerLandingPageURL)
        || /\.com\/twoitems$/.test(referrerLandingPageURL)
        || /\.com\/$/.test(referrerLandingPageURL)
        && getAbValue(constants.abTests.tariffsOnMainPage) === 'b'
      )

      return (
        Boolean(getCookieValue(constants.cookieNames.selectedPlan))
        && getCookieValue(constants.cookieNames.selectedPlan) !== constants.planNames.monthly[1]
        && !isFromUpgradableLanding
      )
    })(),
    withForcedLowerValue: true,
    isFetching: false,
    referralCoupon: false,
  },
  useCredits: true,
  appliedPriceRules: {},
  outOfStockProducts: [],
  selectedPlan: getCookieValue(constants.cookieNames.selectedPlan) || constants.planNames.monthly[1],
  orderInfoForApplePay: null,
  needCleanCreditCardForm: false,
}

export const set = (state, payload) => (
  object.mergeDeep(state, payload)
)

export const setFetching = (state, payload) => (
  object.set(state, 'isFetching', payload)
)

/**
 *
 * @param state
 * @param payload {object}
 * @param payload.isFetching {boolean}
 * @param payload.id {string|number}
 * @param payload.code {string}
 * @param payload.error {string}
 * @returns {*}
 */
export const setCoupon = (state, payload) => (
  object.set(state, 'coupon', payload)
)

/**
 *
 * @param state
 * @param payload {boolean}
 * @returns {*}
 */
export const setCouponDisabled = (state, payload) => (
  object.setIn(state, [ 'coupon', 'isDisabled' ], payload)
)

/**
 *
 * @param state
 * @param payload {boolean}
 * @returns {*}
 */
export const setCouponWithForcedLowerValue = (state, payload) => (
  object.setIn(state, [ 'coupon', 'withForcedLowerValue' ], payload)
)

/**
 *
 * @param state
 * @param payload {string}
 * @returns {*}
 */
export const setSelectedPlan = (state, payload) => (
  object.set(state, 'selectedPlan', payload)
)

/**
 *
 * @param state
 * @param payload {boolean}
 * @returns {*}
 */
export const setBillingError = (state, payload) => (
  object.set(state, 'isBillingError', payload)
)

/**
 *
 * @param state
 * @param payload {string}
 * @returns {*}
 */
export const setCouponError = (state, payload) => (
  object.setIn(state, [ 'coupon', 'error' ], payload)
)

export const updateUseCredits = (state, payload) => (
  object.set(state, 'useCredits', payload)
)

export const setOrderInfoForApplePay = (state, payload) => (
  object.set(state, 'orderInfoForApplePay', payload)
)

export const setOutOfStockProducts = (state, payload) => (
  object.set(state, 'outOfStockProducts', payload)
)

/**
 * Credit card form
 * @param state
 * @param payload {boolean}
 * @returns {*}
 */
export const updateEventForCleanCreditCardForm = (state, payload) => (
  object.set(state, 'needCleanCreditCardForm', payload)
)
